import React, {useEffect, useState} from "react";
import {getStockValuationFxn, getStockValuationReportFxn} from "../actions";
import {Card, Table, DatePicker} from "../../../components/Elements/appUtils";
import moment from "moment";
import InputBoxComponent from "../../../components/Elements/InputBox";
import _ from "lodash"

const OpdReport = () => {
    const [reportData, setReportData] = useState([]);
    const [totalValuation, setTotalValuation] = useState(0);
    const [totalMrpValuation, setTotalMrpValuation] = useState(0);
    const [openingValue, setOpeningValue] = useState(0);
    let [date, setDate] = useState(moment().subtract(1, 'day'));
    const getReportFxn = async (params = {}) => {
        try {
            const {data = {}} = await getStockValuationReportFxn({...params, date});
            const {
                data: report = [],
                totalValue = 0,
                openingValue = 0,
                totalMrpValue = 0
            } = data;
            let sortedList = _.sortBy(report, 'productName')
            setReportData(sortedList);
            setTotalValuation(totalValue);
            setTotalMrpValuation(totalMrpValue);
            setOpeningValue(openingValue);

        } catch (error) {
            setReportData([]);
            setTotalValuation(0);
            setOpeningValue(0);
            setTotalMrpValuation(0);
            console.error("getReportFxn error:", error);
        }
    };

    // Initial load
    useEffect(() => {
        getReportFxn();
    }, [date]);


    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Product Name",
            dataIndex: "productName",
            key: "productName",
            width: 200,
        },
        {
            title: "Product Code",
            dataIndex: "code",
            key: "code",
        },
        {
            title: "HSN",
            dataIndex: "hsnCode",
            key: "hsnCode",
        },

        {
            title: "Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            render: (item) => {
                return item ? `Rs. ${item.toFixed(2)}` : null
            }
        },
        {
            title: "Batch",
            dataIndex: "records",
            key: "records",
            width: '45%',
            render: (record) => {
                return (
                    <>
                        <table className={'table-sm stock_value_table'}>
                            <tr>
                                <th>Batch</th>
                                <th>Purchase Price</th>
                                <th>MRP</th>
                            </tr>
                            {record.map((item) => {
                                return (
                                    <tr key={item._id}>
                                        <td>{item.batchNo}</td>
                                        <td>{item?.quantity} x
                                            Rs. {item?.purchasePrice} = <strong>Rs. {item?.totalPurchasePrice.toFixed(2)}</strong>
                                        </td>
                                        <td>{item.quantity} x
                                            Rs. {item.salePrice} = <strong>Rs. {item.total.toFixed(2)}</strong></td>
                                    </tr>
                                )
                            })}
                        </table>
                    </>
                )
            }
        },
    ];

    return (
        <Card title={`Stock Valuation - (Opening Value Purchase - Rs. ${openingValue?.toFixed(2)})`}>
            <div className={'row'}>
                <div className="col-md-3">
                    <InputBoxComponent title={'Choose Date'} customStyle={{padding: "0 10px 20px"}}>
                        <DatePicker value={date} onChange={(value) => {
                            setDate(value)
                        }}/>
                        {/*<input
                            type="date"
                            className="form-control"
                            value={date}
                            onChange={(e) =>
                                setDate(e.target.value)
                            }
                        />*/}
                    </InputBoxComponent>
                </div>

                <div className="col-md-5"></div>
                <div className="col-md-4 grid-row">
                    <div>
                        Purchase Value <br/>
                        <span>Rs. {totalValuation}</span>
                    </div>
                    <div>
                        MRP Value <br/>
                        <span>Rs. {totalMrpValuation}</span>
                    </div>
                </div>
            </div>
            <div className="row ">
                <div className="col-md-12" key={reportData.length}>
                    <div>
                        <Table
                            dataSource={reportData}
                            columns={columns}
                            rowKey="_id"
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default OpdReport;
